/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaSheetChoice model module.
 * @module model/AqaSheetChoice
 * @version v0
 */
export default class AqaSheetChoice {
  /**
   * Constructs a new <code>AqaSheetChoice</code>.
   * @alias module:model/AqaSheetChoice
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaSheetChoice</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaSheetChoice} obj Optional instance to populate.
   * @return {module:model/AqaSheetChoice} The populated <code>AqaSheetChoice</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaSheetChoice();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('titles'))
        obj.titles = ApiClient.convertToType(data['titles'], ['String']);
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaSheetChoice.prototype.id = undefined;

/**
 * @member {Array.<String>} titles
 */
AqaSheetChoice.prototype.titles = undefined;

